shadow$provide[258] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Operator:{enumerable:true, get:function() {
  return Operator;
}}});
var require$_DOT__DOT__SLASH_base_SLASH_source = require("../base/source");
class Operator extends require$_DOT__DOT__SLASH_base_SLASH_source.Source {
  static initClass() {
    this.traits = ["node", "bind", "operator", "source", "index"];
  }
  indexShader(shader) {
    return __guardMethod__(this.bind.source, "indexShader", o => o.indexShader(shader));
  }
  sourceShader(shader) {
    return __guardMethod__(this.bind.source, "sourceShader", o => o.sourceShader(shader));
  }
  getDimensions() {
    return this.bind.source.getDimensions();
  }
  getFutureDimensions() {
    return this.bind.source.getFutureDimensions();
  }
  getActiveDimensions() {
    return this.bind.source.getActiveDimensions();
  }
  getIndexDimensions() {
    return this.bind.source.getIndexDimensions();
  }
  init() {
    return this.sourceSpec = [{to:"operator.source", trait:"source", optional:true},];
  }
  make() {
    super.make();
    return this._helpers.bind.make(this.sourceSpec);
  }
  made() {
    this.resize();
    return super.made();
  }
  unmake() {
    return this._helpers.bind.unmake();
  }
  resize(_rebuild) {
    return this.trigger({type:"source.resize",});
  }
}
Operator.initClass();
function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}

};